import api from '../services/api'

// OSPROD-NOTIF-L3: register the service worker and (when granted)
// create a Push subscription. Idempotent — re-runs reuse an existing
// subscription. Failures swallowed because push is best-effort.

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = atob(base64)
  const out = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; i++) out[i] = rawData.charCodeAt(i)
  return out
}

export async function ensurePushSubscription(): Promise<{ ok: boolean; reason?: string }> {
  if (typeof window === 'undefined') return { ok: false, reason: 'no window' }
  if (!('serviceWorker' in navigator)) return { ok: false, reason: 'no service worker support' }
  if (!('PushManager' in window)) return { ok: false, reason: 'no PushManager support' }
  if (Notification.permission !== 'granted') return { ok: false, reason: 'notifications not granted' }

  try {
    const reg = await navigator.serviceWorker.register('/sw.js')
    await navigator.serviceWorker.ready

    let sub = await reg.pushManager.getSubscription()
    if (!sub) {
      const res = await api.get<{ publicKey: string }>('/notifications/vapid-public-key')
      const pub = res.data.publicKey
      if (!pub) return { ok: false, reason: 'VAPID public key not configured server-side' }
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(pub).buffer as ArrayBuffer,
      })
    }

    const json = sub.toJSON() as { endpoint?: string; keys?: { p256dh?: string; auth?: string } }
    if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) {
      return { ok: false, reason: 'subscription missing keys' }
    }
    await api.post('/notifications/push/subscribe', {
      endpoint: json.endpoint,
      keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
      userAgent: navigator.userAgent,
    })
    return { ok: true }
  } catch (err) {
    return { ok: false, reason: err instanceof Error ? err.message : 'unknown' }
  }
}

export async function unsubscribePush(): Promise<void> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  try {
    const reg = await navigator.serviceWorker.getRegistration()
    const sub = reg ? await reg.pushManager.getSubscription() : null
    if (sub) {
      await api.post('/notifications/push/unsubscribe', { endpoint: sub.endpoint })
      await sub.unsubscribe()
    }
  } catch { /* swallow */ }
}
